import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="mx-auto flex max-w-[1280px] flex-col items-center px-4 py-28 text-center md:px-6">
      <span className="flex h-20 w-20 items-center justify-center rounded-full bg-accent-100 text-accent-700">
        <i className="ri-emotion-sad-line text-4xl"></i>
      </span>
      <p className="mt-6 font-heading text-6xl font-extrabold text-primary-500">404</p>
      <h1 className="mt-4 font-heading text-2xl font-extrabold text-foreground-950">
        页面走丢了
      </h1>
      <p className="mt-3 max-w-md text-sm text-foreground-600">
        你访问的页面不存在或已被移除，可能是链接输入有误。可以返回首页或前往赛事分类继续浏览。
      </p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-4-line"></i>
          返回首页
        </Link>
        <Link
          to="/category"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
        >
          浏览赛事分类
        </Link>
      </div>
    </div>
  );
}